"use client";

import clsx from "clsx";
import { Link } from "@repo/next-utils/router";
import { useBag } from "@repo/ui/bag";
import { Button } from "@repo/ui/button";
import { VisuallyHidden } from "@repo/ui/visually-hidden";
import { BagIcon } from "@/theme/icons/bag";
import styles from "./nav.module.css";

export type BagCounterProps = {
  className?: string;
};

const maxLabelValue = 99;

export const BagCounter = ({ className }: BagCounterProps) => {
  const { totalQuantity } = useBag();
  const totalLabelValue = Math.min(totalQuantity, maxLabelValue);
  const showCount = !!totalLabelValue;

  const hasExceededMaxCount = totalQuantity > maxLabelValue;

  return (
    <Button size="icon" asChild>
      <Link href="/bag" className={styles.badgeContainer}>
        <BagIcon
          filled={showCount}
          className={className}
          label="View your bag."
        />
        {showCount && (
          <span
            className={clsx(
              className,
              styles.badge,
              hasExceededMaxCount && styles.maxCount,
            )}
          >
            {totalLabelValue}
            {hasExceededMaxCount ? "+" : ""}
            <VisuallyHidden>
              {totalLabelValue === 1 ? "item in your bag" : "items in your bag"}
            </VisuallyHidden>
          </span>
        )}
      </Link>
    </Button>
  );
};
